<h5 class="center">Can't find that page, but is this what you are looking for?</h5>
<div>
  <img class='steven' src="/assets/404.gif"/>
</div>